module.exports = __webpack_public_path__ + "img/hr-sand-rock-medium-01.a63ce0cf.png";